export default __webpack_public_path__ + "static/media/food-point-lists.3ebb4bc9.png";